import { prepareApp } from '../Config/config.saga';
import { loginCallOptions } from '../../services/auth.services';
import { callApi } from '../api';
import { login, loginSuccess } from './auth.actions';
import { User } from './auth.reducer';
import { call, put, take, takeEvery } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import {
  wrongLdapCredentials,
  usernameOrPasswordMissing,
} from '../Errors/errors.saga';

export function* watchForLogin() {
  while (true) {
    const {
      payload: { username, password },
    } = yield take(login.type);
    if (!username || !password) {
      yield call(usernameOrPasswordMissing);
    } else {
      yield startAuthentication(username, password);
    }
  }
}

function* afterLoginSuccess() {
  yield put(push('/stories'));
}

export function* watchForLoginSuccess() {
  yield takeEvery(loginSuccess.type, afterLoginSuccess);
}

function* startAuthentication(username: string, password: string) {
  const callOptions = loginCallOptions(username, password);

  const data = yield call(callApi, callOptions);
  if (data && data.ok) {
    yield put(
      loginSuccess({
        isLoggedIn: true,
        token: data.data.token,
        username: username,
      } as User)
    );
    yield prepareApp();
  } else {
    yield call(wrongLdapCredentials);
  }
}



// WEBPACK FOOTER //
// ./src/store/Auth/auth.saga.ts